import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from './ResponseSuccess.module.css'

interface Props {
    success: number | null
}

let ResponseSuccess = ({success}: Props) => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <div
            className={style.container}
            style={{
                border: `1px solid ${Colors[theme ?? 'light'].borderLight}`,
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].secondBackground,
                //boxShadow: `0px 0px 5px ${Colors[theme ?? 'light'].shadow}`
            }}
        >
            {success
                ? <>
                    <div className={style.icon}>
                        <i className="fas fa-circle-check"></i>
                    </div>
                    <div className={style.text}>
                        {Strings[language ?? 'tm']['success' + success]}!
                    </div>
                </>
                : null
            }
        </div>
    )
}

export default ResponseSuccess